import React, {
  Fragment,
  useEffect,
  useState,
  useMemo
} from 'react';
import { useIdleTimer } from 'react-idle-timer';

import { useAuth } from '@lib/authentication';

import SessionExpiredModal from './SessionExpiredModal';
import SessionExpiringSoonModal from './SessionExpiringSoonModal';

const REMAINING_SESSION_TIME_TO_EXPIRE = 60000;

const SessionTimeManager = () => {
  const { logout, refresh, token } = useAuth();
  const totalTimeForTheSessionToExpire = useMemo(
    () => (token?.expirationTimeInMilliseconds),
    [token]
  );

  const [isDisplaySessionExpiredModal, setIsDisplaySessionExpiredModal] = useState(false);
  const [isDisplaySessionExpiringSoonModal, setIsDisplaySessionExpiringSoonModal] = useState(false);

  const idleTimer = useIdleTimer({
    timeout: totalTimeForTheSessionToExpire,
    onIdle: (_, { pause }) => {
      pause();
    },
    promptBeforeIdle: REMAINING_SESSION_TIME_TO_EXPIRE,
    onPrompt: () => setIsDisplaySessionExpiringSoonModal(true)
  });

  const onSessionExpired = () => {
    setIsDisplaySessionExpiringSoonModal(false);
    setIsDisplaySessionExpiredModal(true);
  };

  const onContinueBrowsing = async () => {
    setIsDisplaySessionExpiringSoonModal(false);

    await refresh();
    idleTimer.reset();
  };

  useEffect(() => {
    if (!token?.isExpired() && totalTimeForTheSessionToExpire) {
      idleTimer.start();
    } else {
      logout();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      {isDisplaySessionExpiringSoonModal && (
        <SessionExpiringSoonModal
          onContinueBrowsing={onContinueBrowsing}
          onSessionExpired={onSessionExpired}
        />
      )}

      <SessionExpiredModal isOpen={isDisplaySessionExpiredModal} />
    </Fragment>
  );
};

export default SessionTimeManager;
